import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getProductSetsListFetchSuccess, getProductSetsListFetchFailure } from './reducer';
import { ProductSetsListResType } from 'src/types/productSetsList';

const getProductSetsListFetchRequest = async () => {
    const res = await api('get', 'api/secure/products/set');
    return res.data.data;
};

function* getProductSetsListFetch() {
    try {
        const response: ProductSetsListResType = yield call((): any => getProductSetsListFetchRequest());
        yield put(getProductSetsListFetchSuccess(response));
    } catch (error) {
        yield put(getProductSetsListFetchFailure({ error }));
    }
}

export function* getProductSetsListFetchWatch() {
    yield takeEvery('productSetsList/getProductSetsListFetch', getProductSetsListFetch);
}
